<template>
  <div class="container">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-form-item label="姓名">
        <a-input placeholder="请输入姓名" v-decorator="['name']" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit" style="margin-right: 8px">
          查询
        </a-button>
        <a-button @click="resetForm">
          重置
        </a-button>
      </a-form-item>
    </a-form>
    <a-button
      type="primary"
      icon="plus"
      @click="handleAdd"
      style="margin: 20px 0;"
      >新增用户</a-button
    >
    <div>
      <a-table
        :columns="columns"
        :data-source="list"
        rowKey="id"
        :pagination="{
          current: page,
          total: total,
          pageSize: size,
          onChange: onPageChange
        }"
      >
        <template slot="idx" slot-scope="text, record, index">
          {{ (page - 1) * size + index + 1 }}
        </template>
        <template slot="created_at" slot-scope="text">
          {{ text | timeFormat }}
        </template>
        <template slot="operation" slot-scope="text, record">
          <a-popconfirm
            @confirm="handleDelete(record)"
            @cancel="$message.warning('取消删除')"
            title="确定删除吗？"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </div>
    <add-or-edit-people
      :visible.sync="visible"
      @onOk="
        v => {
          visible = v;
          getUserList();
        }
      "
    ></add-or-edit-people>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { getOperationUserList, deleteOperationUser } from "@/api/api";
import moment from "moment";
import AddOrEditPeople from "./components/AddOrEditPeople";
import { pepole_list_columns } from "@/options/columns";

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      columns: pepole_list_columns,
      list: [],
      visible: false,
      action: "",
      page: 1,
      size: 10,
      total: 0
    };
  },
  components: {
    AddOrEditPeople
  },
  computed: {
    ...mapState(["authUserInfo", "clientInfo"]),
    ...mapGetters(["defaultInfo"])
  },
  filters: {
    timeFormat(v) {
      if (!v) {
        return "";
      }
      return moment(v).format("YYYY-MM-DD HH:mm:ss");
    }
  },
  mounted() {
    this.getUserList();
  },
  methods: {
    async getUserList() {
      try {
        let search = this.form.getFieldValue("name");
        if (!search) {
          search = "";
        }
        let res = await getOperationUserList({
          group_id: this.defaultInfo.defaultGroupId,
          page: this.page,
          size: this.size,
          search: search
        });
        this.list = res.data.items;
        this.total = res.data.total;
      } catch (error) {
        console.log(error);
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          this.getUserList();
        }
      });
    },
    resetForm() {
      this.form.resetFields();
      this.getUserList();
    },
    handleAdd() {
      this.action = "add";
      this.visible = true;
    },
    onPageChange(v) {
      this.page = v;
      this.getUserList();
    },
    async handleDelete(record) {
      try {
        await deleteOperationUser(record.id);
        this.$message.success("删除成功");
        await this.$store.dispatch("getOperationUserList");
        await this.getUserList();
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.container {
  padding: 10px;
}
</style>
